// extracted by mini-css-extract-plugin
export var infoItem = "_l5-1";
export var title = "_l5-0";